import { useQuery } from '@apollo/client/react';

import { MAX_COUNT } from '~/constants/medication_followup_questionnaire';
import { GetMedicationFollowupQuestionnairesSelectDocument } from '~/graphql/generated/graphql';
import { getMe } from '~/graphql/utility';

export const useMedicationFollowupQuestionnaires = () => {
  const { data, loading } = useQuery(GetMedicationFollowupQuestionnairesSelectDocument, {
    fetchPolicy: 'cache-and-network',
    variables: {
      perPage: MAX_COUNT,
    },
  });
  const questionnaires = data
    ? getMe(data)?.organization.medicationFollowupQuestionnaires.nodes
    : [];
  return { questionnaires, loading };
};
